__turbopack_context__.v({
  "block-img": "GV-Oma_block-img",
  "blue-box": "GV-Oma_blue-box",
  "box-media-text": "GV-Oma_box-media-text",
  "disclaimer": "GV-Oma_disclaimer",
  "hr": "GV-Oma_hr",
  "text-center": "GV-Oma_text-center",
  "text-heading": "GV-Oma_text-heading",
});
